import React from 'react'
import styled from 'styled-components'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import { Text } from 'components/Text'

const Root = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > p {
    opacity: 1 !important;
  }
`

export const EventChip = ({ color, logo, name, url }) => {
  const image = getImage(logo)
  return (
    <Root as="a" target="_blank" rel="noreferrer" href={url} $color={color}>
      <GatsbyImage image={image} style={{ marginRight: 8 }} />
      <Text color={color}>{name}</Text>
    </Root>
  )
}
